import { Pipe, PipeTransform } from '@angular/core';

import { CompanyLanguage } from '@ninety/mobile/platform/api';

import { NotificationItemType } from '../models/notification-item-type';

@Pipe({
  name: 'itemsName',
})
export class ItemsNamePipe implements PipeTransform {
  transform(itemType: NotificationItemType, language: CompanyLanguage | null): string {
    switch (itemType) {
      case NotificationItemType.rock:
        return language?.rock?.items ?? 'Rocks';
      case NotificationItemType.milestone:
        return language?.milestone?.items ?? 'Milestones';
      case NotificationItemType.todo:
        return language?.todo?.items ?? 'To-Dos';
      case NotificationItemType.shortTermIssue:
        return `${language?.issue?.shortTerm ?? 'Short-term'} ${language?.issue?.items ?? 'Issues'}`;
      case NotificationItemType.longTermIssue:
        return `${language?.issue?.longTerm ?? 'Long-term'} ${language?.issue?.items ?? 'Issues'}`;
      case NotificationItemType.headline:
        return language?.headline?.items ?? 'Headlines';
      case NotificationItemType.cascadingMessage:
        return language?.cascadingMessage?.items ?? 'Cascading Messages';
      default:
        return '';
    }
  }
}
